import { render } from "./XeGpsTrangThai.vue?vue&type=template&id=63ed444a&scoped=true"
import script from "./XeGpsTrangThai.vue?vue&type=script&lang=js"
export * from "./XeGpsTrangThai.vue?vue&type=script&lang=js"

import "./XeGpsTrangThai.vue?vue&type=style&index=0&id=63ed444a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ed444a"]])

export default __exports__